import { Department, Subscription, User } from 'services/api';
import { mapSubscriptionDurationToMonth } from 'src/utils/format-user-subscription-details';

export enum SubscriptionActions {
  Subscriptions = 'subscriptions',
  Subscribe = 'subscribe',
  Unsubscribe = 'unsubscribe',
  SubscribeConfirm = 'subscribe-confirm'
}

export enum SubscriptionListingViews {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed'
}

export enum SelectionType {
  Department = 'department',
  Employee = 'employee'
}

export interface SubscribedListingData
  extends Pick<User, 'id' | 'name' | 'email'> {
  subscription_start_date: Subscription['start_date'];
  subscription_end_date: Subscription['end_date'];
  subscription_plan: ReturnType<typeof mapSubscriptionDurationToMonth>;
  subscription_state: Subscription['state'];
}

export interface UnsubscribedListingData
  extends Pick<User, 'id' | 'name' | 'email'> {
  department_name: Department['name'];
}
